import bsBreakpoints from 'bs-breakpoints'

export default function detectCols () {
  bsBreakpoints.detectBreakpoint()
  const breakpoint = bsBreakpoints.getCurrentBreakpoint()
  if (breakpoint === 'xLarge') {
    return 4
  } else if (breakpoint === 'medium' || breakpoint === 'large') {
    return 3
  } else if (breakpoint === 'small') {
    return 2
  } else {
    return 1
  }
}
